export default __webpack_public_path__ + "static/779-e638146cd366a1565650bbc8325a1bb9.gif";